import coursesApi from 'Api/axios/courses-api';
import employeesApi from 'Api/axios/employees-api';
import { useEffect, useState } from 'react';
import type { UserFilterI, UserI } from 'types';

interface Props {
  init?: boolean;
}

const useEmployeeApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<UserI[]>([]);
  const [employee, setEmployee] = useState<UserI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Obtiene todos los empleados.
   * @param filters - Filtros para la consulta.
   */
  const fetchEmployees = async (filters: UserFilterI) => {
    setLoading(true);
    const response = await employeesApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  /**
   * Obtiene un empleado por su ID.
   * @param id - ID del empleado.
   */
  const fetchEmployeeById = async (id: string) => {
    setLoading(true);
    const response = await employeesApi.readUnique(id);
    setEmployee(response.data ?? null);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchEmployees({});
    }
  }, [init]);

  return { data, employee, loading, error, fetchEmployees, fetchEmployeeById };
};

export default useEmployeeApi;
